import { render, staticRenderFns } from "./SuggestionBarItem.vue?vue&type=template&id=624b111e&scoped=true&"
import script from "./SuggestionBarItem.vue?vue&type=script&lang=js&"
export * from "./SuggestionBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBarItem.vue?vue&type=style&index=0&id=624b111e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624b111e",
  null
  
)

export default component.exports